import find from 'lodash/find';
import map from 'lodash/map';
import memoize from 'lodash/memoize';

let iconNodes = null;

function getNodeData(node) {
  return {
    name: node.id,
    bBox: node.getBBox(),
    pathData: node.getAttribute('d'),
    node: node
  };
}

function getAllCustomIcons() {
  if (iconNodes != null) {
    return iconNodes;
  }

  const rawNodes = document
    .getElementById('custom-icons')
    .querySelectorAll("[id^='custom-icon-']");

  if (rawNodes.length) {
    iconNodes = map(rawNodes, getNodeData);
  }

  return iconNodes.length ? iconNodes : null;
}

export default function getCustomIcon(name) {
  let getAllCustomIconsMemoized = memoize(getAllCustomIcons);
  return find(getAllCustomIconsMemoized(), i => i.name === name);
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seats/getCustomIcon.js